import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss']
})
export class ExchangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('.grecaptcha-badge').hide();
  }

}
